import { QueryCache, QueryClient } from '@tanstack/react-query';
import { handleAuthenticationError } from '@/features/auth/authErrorHandler.ts';
import { HttpError } from '@/lib/fetchClient';
import { HTTP_STATUS } from '@/constants';

const isUnauthorized = (error: unknown): boolean =>
  error instanceof HttpError && error.response.status === HTTP_STATUS.UNAUTHORIZED;

const isForbidden = (error: unknown): boolean =>
  error instanceof HttpError && error.response.status === HTTP_STATUS.FORBIDDEN;

const isServerError = (error: unknown): boolean =>
  error instanceof HttpError && error.response.status >= HTTP_STATUS.SERVER_ERROR;

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      console.error('[query failed]', query.queryKey, error);
    },
  }),
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Don't retry on 401 (handled by fetchClient) or on 5xx server errors after 1 attempt
        if (isUnauthorized(error)) return false;
        if (isForbidden(error)) return false;
        if (isServerError(error) && failureCount >= 1) return false;
        return failureCount < 2;
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      onError: error => {
        if (isUnauthorized(error)) handleAuthenticationError((error as HttpError).response);
      },
    },
  },
});
